<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-row>
            <v-col class="my-2">
                <span class="black--text font-weight-medium mr-2">LIGHTING MODE:</span>
                <v-btn-toggle v-model="lightingMode">
                        <v-btn text value="Torch">
                        Pulse
                    </v-btn>
                    <v-btn text value="Flash">
                        Flash
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <span v-show="!flashOn">
            <span class="black--text font-weight-medium mr-2">PULSE BRIGHTNESS LEVEL:</span><span class="black--text font-weight-bold">{{torchLevelFormatted}}</span>
            <v-slider
                v-model="torchLevel"
                prepend-icon="mdi-brightness-7"
                append-icon="mdi-brightness-5"
                ticks="always"
                tick-size="8"
                track-color="black"
                track-fill-color="green"
                min="0"
                max="10"
                thumb-color="blue"
                background-color="white">
            </v-slider>
            <span class="black--text font-weight-medium mr-2">PULSE DURATION:</span><span class="black--text font-weight-bold">{{torchDurationFormatted}}</span>
            <v-slider
                v-model="torchDuration"
                step="0.5"
                ticks="always"
                tick-size="8"
                track-color="black"
                track-fill-color="green"
                min="1"
                max="15"
                thumb-color="blue"
                background-color="white">
                <template v-slot:prepend>
                    <span class="black--text font-weight-bold">1</span>
                </template>
                <template v-slot:append>
                    <span class="black--text font-weight-bold">15</span>
                </template>
            </v-slider>
            </span>
            <span class="black--text font-weight-medium mr-2">RECORDING DURATION:</span><span class="black--text font-weight-bold">{{recordingDurationFormatted}}</span>
            <v-slider
                v-model="recordingDuration"
                step="0.5"
                ticks="always"
                tick-size="8"
                track-color="black"
                track-fill-color="green"
                min="1"
                max="15"
                thumb-color="blue"
                background-color="white">
                <template v-slot:prepend>
                    <span class="black--text font-weight-bold">1</span>
                </template>
                <template v-slot:append>
                    <span class="black--text font-weight-bold">15</span>
                </template>
            </v-slider>
            <span class="black--text font-weight-medium mr-2">AMBIENT ADAPT BRIGHTNESS LEVEL:</span><span class="black--text font-weight-bold">{{ambientAdaptBrightnessLevelFormatted}}</span>
            <v-slider
                v-model="ambientAdaptBrightnessLevel"
                prepend-icon="mdi-brightness-7"
                append-icon="mdi-brightness-5"
                ticks="always"
                tick-size="8"
                track-color="black"
                track-fill-color="green"
                min="0"
                max="10"
                thumb-color="blue"
                background-color="white">
            </v-slider>
            <span class="black--text font-weight-medium mr-2">ILLUMINATION DELAY:</span><span class="black--text font-weight-bold">{{illuminationDelayFormatted}}</span>
            <v-slider
                v-model="illuminationDelay"
                step="0.5"
                ticks="always"
                tick-size="8"
                track-color="black"
                track-fill-color="green"
                min="0"
                max="5"
                thumb-color="blue"
                background-color="white">
                <template v-slot:prepend>
                    <span class="black--text font-weight-bold">0</span>
                </template>
                <template v-slot:append>
                    <span class="black--text font-weight-bold">5</span>
                </template>
            </v-slider>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default
    {
        name: 'recording-settings',
        computed:
        {
            ...mapState('auth',
            {
                currentUserChanges: state => state.currentUserChanges ? state.currentUserChanges : {preferences: {}}
            }),
            title()
            {
                const actualVideoDuration = this.currentUserChanges.preferences.videoDuration - this.currentUserChanges.preferences.illuminationDelay
                // If No light
                if (false === this.currentUserChanges.preferences.flashOn && 0 === this.currentUserChanges.preferences.torchLevel)
                {
                    return "Recording Settings - No Light Mode"
                }
                // If full spectrum
                if (true === this.currentUserChanges.preferences.flashOn || this.currentUserChanges.preferences.torchDuration < actualVideoDuration)
                {
                    return "Recording Settings - Full Spectrum Mode"
                }
                // Else constrict
                return "Recording Settings - Constrict Mode"
            },
            lightingMode:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.flashOn ? 'Flash' : 'Torch'
                },
                set: function(newValue)
                {
                    this.currentUserChanges.preferences.flashOn = newValue === 'Flash'
                }
            },
            torchLevel:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.torchLevel * 10
                },
                set: function(newValue)
                {
                    this.currentUserChanges.preferences.torchLevel = newValue / 10
                }
            },
            torchLevelFormatted()
            {
                return `${(Math.round(this.currentUserChanges.preferences.torchLevel + 'e+1') + 'e-1') * 100}%`
            },
            ambientAdaptBrightnessLevel:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.ambientLevel * 100
                },
                set: function(newValue)
                {
                    this.currentUserChanges.preferences.ambientLevel = newValue / 100
                }
            },
            ambientAdaptBrightnessLevelFormatted()
            {
                return `${(Math.round(this.currentUserChanges.preferences.ambientLevel + 'e+10') + 'e-10') * 100}%`
            },
            illuminationDelay:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.illuminationDelay
                },
                set: function(newValue)
                {
                    this.currentUserChanges.preferences.illuminationDelay = newValue
                }
            },
            illuminationDelayFormatted()
            {
                return`${this.currentUserChanges.preferences.illuminationDelay} Seconds`
            },
            flashOn()
            {
                return 'flashOn' in this.currentUserChanges.preferences ? this.currentUserChanges.preferences.flashOn : false
            },
            torchDuration:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.torchDuration
                },
                set: function (newValue)
                {
                    this.currentUserChanges.preferences.torchDuration = newValue
                }
            },
            torchDurationFormatted()
            {
                return`${this.currentUserChanges.preferences.torchDuration} Seconds`
            },
            recordingDuration:
            {
                get: function()
                {
                    return this.currentUserChanges.preferences.videoDuration
                },
                set: function(newValue)
                {
                    this.currentUserChanges.preferences.videoDuration = newValue
                }
            },
            recordingDurationFormatted()
            {
                return `${this.currentUserChanges.preferences.videoDuration} Seconds`
            }
        }
    };
</script>

<style scoped>

</style>